module.exports = __webpack_public_path__ + "img/CHS_play_highlight.16e61365.png";